const graphics = {
    iconIllustration: {
        width: '12rem',
        height: '12rem',
        margin: '3.6rem 0 4.8rem'
    }
};
export default graphics;
//# sourceMappingURL=graphics.js.map